module.exports = __webpack_public_path__ + "assets/-_5.8d685cab.svg";